var render, staticRenderFns
import script from "./match_object_item.vue?vue&type=script&lang=js&"
export * from "./match_object_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bab5aad')) {
      api.createRecord('0bab5aad', component.options)
    } else {
      api.reload('0bab5aad', component.options)
    }
    
  }
}
component.options.__file = "found/views/config_center/view/list/approval/form/components/match_object/match_object_item.vue"
export default component.exports